/// <amd-module name="Dashboards/Directory/DashboardsDirectoryConstants" />
import * as Resources from "Dashboards/Directory/Resources";
import { ColumnActionsMode } from "OfficeFabric/DetailsList";

export const FeatureName = "Dashboards";
export const ScenarioName = "Dashboards.Directory";
export const ScenarioNameNewDashboardDirectory = "Dashboards.Directory.NWP";

export const myDashboardsDataProviderId = "ms.vss-dashboards-web.my-dashboards-data-provider";
export const favoritesDataProviderId = "ms.vss-dashboards-web.favorite-dashboards-data-provider";
export const myOwnersDataProviderId = "ms.vss-dashboards-web.my-team-list-data-provider";
export const mruDashboardDataProviderId = "ms.vss-dashboards-web.mru-dashboard-data-provider";
export const allDashboardsDataProviderId = "ms.vss-dashboards-web.all-dashboards-data-provider";

export const WebAccessDashboardsSecurityDialog = "WebAccess.Dashboards.SecurityDialog";
export const SecurityNameSpaceIdForDashboards = "8ADF73B7-389A-4276-B638-FE1653F7EFC7";


export const ColumnKeys = {
    Team: "Team",
    DashboardType: "DashboardType",
    Description: "Description",
    Owner: "Owner",
    ModifiedBy: "ModifiedBy",
    LastAccessedDate: "LastAccessedDate",
    ModifiedDate: "ModifiedDate"
};

export const DashboardTypeColumn = {
    fieldName: ColumnKeys.DashboardType,
    key: ColumnKeys.DashboardType,
    name: Resources.DashboardTypeColumnHeader,
    minWidth: 200,
    maxWidth: 400,
    isResizable: true,
    columnActionsMode: ColumnActionsMode.disabled
};

export const OwnerColumn = {
    fieldName: ColumnKeys.Owner,
    key: ColumnKeys.Owner,
    name: Resources.OwnerColumnHeader,
    minWidth: 200,
    maxWidth: 400,
    isResizable: true,
    columnActionsMode: ColumnActionsMode.disabled
};

export const TeamColumn = {
    fieldName: ColumnKeys.Team,
    key: ColumnKeys.Team,
    name: Resources.TeamColumnHeader,
    minWidth: 200,
    maxWidth: 400,
    isResizable: true,
    columnActionsMode: ColumnActionsMode.disabled
};

export const DescriptionColumn = {
    fieldName: ColumnKeys.Description,
    key: ColumnKeys.Description,
    name: Resources.DescriptionColumnHeader,
    minWidth: 200,
    maxWidth: 400,
    isResizable: true,
    columnActionsMode: ColumnActionsMode.disabled
};

export const LastAccessedDateColumn = {
    fieldName: ColumnKeys.LastAccessedDate,
    key: ColumnKeys.LastAccessedDate,
    name: Resources.LastAccessedDateColumnHeader,
    minWidth: 200,
    maxWidth: 400,
    isResizable: true,
    columnActionsMode: ColumnActionsMode.disabled
};

export const ModifiedByColumn = {
    fieldName: ColumnKeys.ModifiedBy,
    key: ColumnKeys.ModifiedBy,
    name: Resources.ModifiedByColumnHeader,
    minWidth: 250,
    maxWidth: 400,
    isResizable: true,
    columnActionsMode: ColumnActionsMode.disabled
};

export namespace DirectoryFilterKeys {
    export const KEYWORD_FILTER_KEY = "Keyword";
    export const TEAM_FILTER_KEY = "Team";
    export const DASHBOARD_TYPE_FILTER_KEY = "DashboardType";
}
